<div *ngIf="(loading$ | async)" class="dialog-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>

<div class="dialog-title-content">
    <div class="dialog-title">{{ 'modules.crm.leads.changeStatusDialog.title' | translate }}</div>
    <div (click)="closeDialog(false)" class="dialog-close">
        <mat-icon>close</mat-icon>
    </div>
</div>

<div [ngClass]="success ? 'no-buttons-row' : ''" class="dialog-content scrollable">
    <form [formGroup]="statusForm" autocomplete="off" class="dialog-form scroll-content-padding df-c gap25">

        <div *ngIf="!data.status" class="df jc-c ai-c gap30">
            <div (click)="success = true" [ngClass]="success ? 'selected' : ''" class="success-icon clickable">
                <mat-icon>thumb_up</mat-icon>
            </div>
            <div (click)="success = false" [ngClass]="!success ? 'selected' : ''" class="unsuccessful-icon clickable">
                <mat-icon>thumb_down</mat-icon>
            </div>
        </div>

        <div *ngIf="success" class="df-c gap15">
            <div class="df jc-s ai-c gap15">
                <span class="dialog-subtitle-label success">{{ 'modules.crm.leads.changeStatusDialog.successful.title' | translate }}</span>
                <mat-divider class="grow"></mat-divider>
            </div>

            <div class="df gap20">
                <div (click)="createProject()" class="selection-item clickable grow df jc-s ai-c">
                    <mat-icon>playlist_add</mat-icon>
                    <span>{{ 'modules.crm.leads.changeStatusDialog.successful.createProject' | translate }}</span>
                </div>
                <div class="df-c grow gap10">
                    <div (click)="openProjects()" class="selection-item clickable grow">
                        <mat-icon>playlist_add</mat-icon>
                        <span>{{ 'modules.crm.leads.changeStatusDialog.successful.addToProject' | translate }}</span>
                    </div>
                    <div (click)="completeAsClient()" class="selection-item clickable grow">
                        <mat-icon>done_all</mat-icon>
                        <span>{{ 'modules.crm.leads.changeStatusDialog.successful.clientAlready' | translate }}</span>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="!success" class="df-c gap15">
            <div class="df jc-s ai-c gap15">
                <span class="dialog-subtitle-label unsuccessful">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.title' | translate }}</span>
                <mat-divider class="grow"></mat-divider>
            </div>

            <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
                <mat-label>{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.type' | translate }}</mat-label>
                <mat-select (selectionChange)="validateComment($event)" class="select-panel" disableOptionCentering="true" formControlName="type" panelClass="dialog-select-panel">
                    <mat-option [value]="'NOT_NEED'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.NOT_NEED' | translate }}</mat-option>
                    <mat-option [value]="'NO_ANSWER'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.NO_ANSWER' | translate }}</mat-option>
                    <mat-option [value]="'EXPENSIVE'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.EXPENSIVE' | translate }}</mat-option>
                    <mat-option [value]="'OTHER_SOFT'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.OTHER_SOFT' | translate }}</mat-option>
                    <mat-option [value]="'INVALID_NUMBER'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.INVALID_NUMBER' | translate }}</mat-option>
                    <mat-option [value]="'NON_GOAL'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.NON_GOAL' | translate }}</mat-option>
                    <mat-option [value]="'NON_LPR'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.NON_LPR' | translate }}</mat-option>
                    <mat-option [value]="'HOUSING_OFFICE_SERVICE'">{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.types.HOUSING_OFFICE_SERVICE' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <div class="df-c gap10">
                <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
                    <mat-label>{{ 'modules.crm.leads.changeStatusDialog.unsuccessful.commentTypes.' + statusForm.get('type')?.value | translate }}</mat-label>
                    <textarea cdkAutosizeMaxRows="3" cdkAutosizeMinRows="1" cdkTextareaAutosize formControlName="comment" matInput></textarea>
                </mat-form-field>

                <div *ngIf="statusForm.get('type')?.value === 'OTHER_SOFT'" class="df fw-w gap10">
                    <span (click)="statusForm.get('comment')?.setValue('ОСББ онлайн')" class="rounded-item clickable">{{ 'ОСББ онлайн' }}</span>
                    <span (click)="statusForm.get('comment')?.setValue('ОСББ 365')" class="rounded-item clickable">{{ 'ОСББ 365' }}</span>
                    <span (click)="statusForm.get('comment')?.setValue('1с')" class="rounded-item clickable">{{ '1с' }}</span>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="!success" class="buttons-row df jc-e ai-c gap20">
    <button (click)="submitForm()" [disabled]="statusForm.invalid" class="default-button apply-button-flat">
        {{ 'common.save' | translate }}
    </button>
</div>
